import { render, staticRenderFns } from "./CheckoutSummary.vue?vue&type=template&id=774672ce"
import script from "./CheckoutSummary.vue?vue&type=script&lang=js"
export * from "./CheckoutSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports